class CustomServices {
    constructor() {
        this.options = {
            root: null,
            rootMargin: "0px",
            threshold: 0.4
        };
    }

    revealCallback = (entries) => {
        entries.forEach((entry) => {
            let container = entry.target;

            if (entry.isIntersecting) {
                console.log(container);
                container.classList.add("animating");
                return;
            }

            if (entry.boundingClientRect.top > 0) {
                container.classList.remove("animating");
            }
        });
    }

    fadeupCallback = (entries) => {
        entries.forEach((entry) => {
            let container = entry.target;
            container.classList.add("not-fading-up");

            if (entry.isIntersecting) {
                container.classList.add("fading-up");
                return;
            }

            if (entry.boundingClientRect.top > 0) {
                container.classList.remove("fading-up");
            }
        });
    }

    initAnimations = () => {
        const revealObserver = new IntersectionObserver(this.revealCallback, this.options);
        const fadeupObserver = new IntersectionObserver(this.fadeupCallback, this.options);

        document.querySelectorAll(".reveal").forEach((reveal) => {
            revealObserver.observe(reveal);
        });

        document.querySelectorAll(".fadeup").forEach((fadeup) => {
            fadeupObserver.observe(fadeup);
        });
    }
}

export default CustomServices;